<template>
  <div id="language" v-if="visible">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'LanguageComponent',
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    ...mapState({
      languages: (state) => state.app.languages,
      preferedLanguage: (state) => state.app.preferedLanguage,
    }),
  },
  created() {
    const urlLang = this.$route.fullPath.split('/')[1];
    let lang = null;
    if (this.languages.includes(urlLang)) {
      lang = urlLang;
    } else {
      // 1. theres a previous set language in localStorage
      const storedLang = localStorage.getItem('language');
      if (typeof storedLang !== 'undefined' && this.languages !== null) {
        if (this.languages.includes(storedLang)) {
          lang = storedLang;
        }
        // 2. if previous fails check browser prefered languages
      } else if (window.navigator.languages.includes(this.preferedLanguage)) {
        lang = this.preferedLanguage.substring(0, 2);
      } else {
        window.navigator.languages.find((l) => {
          let subL = l.substring(l);
          if (this.languages.includes(subL)) {
            lang = subL;
            return true;
          }
        });
      }
      if (lang === '' || lang === null) {
        [lang] = this.languages;
      }
      let fullPath = this.$route.fullPath;
      if (fullPath === '/') {
        fullPath = '';
      }
      window.location = `/${lang}${fullPath}`;
      return;
    }

    if (lang !== '') {
      this.$store.dispatch('setLanguage', lang);
    } else if (this.$route.params.lang !== '') {
      lang = this.$route.params.lang;
    } else {
      lang = this.preferedLanguage.substring(0, 2);
      this.$router.replace({ params: { lang } });
    }
    document.documentElement.setAttribute('lang', lang);
    this.$store.dispatch('setLanguage', lang);
    this.$i18n.locale = lang;
    localStorage.setItem('language', lang);
    if (this.$route.path === '/') {
      this.$router.push(`/${lang}`);
    }
    this.visible = true;
  },
};
</script>
